<template>
  <div>
    <ol class="breadcrumb" style="border-radius:0" >
      <li class="breadcrumb-item">
        <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('reports.url')">
          {{ $t('reports.name') }}
        </router-link>
      </li>
      <li class="breadcrumb-item" aria-current="page">{{ $t('invoices.issued') }}</li>
    </ol>
    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('invoices.issued') }}
            -
            {{monthName}}
            {{year}}
            <button @click="excel" class="btn btn-primary mr-1">
              <i class="fa fa-table"></i> Excel .xls
            </button>
            <button @click="download" class="btn btn-primary">
              <i class="fa fa-download"></i> Minimax .xml
            </button>
          </h1>
          <p class="lead text-muted">
            {{ $t('invoices.issued') }}
            {{ $t('forProperty') }}
            {{property.name}}
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="table-responsive">
            <table id="invoice-report" class="table table-bordered table-vcenter" style="width:100%;">
              <thead>
                <tr>
                  <th rowspan="3">Zap. št.</th>
                  <th colspan="6">Listina</th>
                  <th rowspan="3">Vrednost z DDV</th>
                  <th rowspan="3">Dobave blaga in storitev iz 76.a člena</th>
                  <th colspan="7">Oproščen promet</th>
                  <th colspan="6">Obdavčen promet - DDV</th>
                  <th rowspan="3">Neobdavčjiv promet, ki prinaša pravico do odbitka DDV</th>
                  <th rowspan="3">Opombe</th>
                  <th rowspan="3">Obrnjeno davčno breme brez DDV</th>
                </tr>
                <tr>
                  <th rowspan="2">Davč. obd.</th>
                  <th rowspan="2">Datum knjižbe</th>
                  <th rowspan="2">Številka listine</th>
                  <th rowspan="2">Datum listine</th>
                  <th colspan="2">Kupec</th>
                  <th rowspan="2">Brez pravice do odbitka DDV</th>
                  <th colspan="3">Dobave v EU</th>
                  <th rowspan="2">Tristranske dobave v EU</th>
                  <th rowspan="2">Prodaja blaga na daljavo v EU</th>
                  <th rowspan="2">Prodaja blaga z montažo EU</th>
                  <th colspan="6">Promet v Sloveniji</th>
                </tr>
                <tr>
                  <th>Firma/ime ter sedež</th>
                  <th>ID za DDV</th>
                  <th>Blago</th>
                  <th>Storitve</th>
                  <th>Car.p. 42, 63</th>
                  <th>Osnova</th>
                  <th>22%</th>
                  <th>Osnova</th>
                  <th>9,5%</th>
                  <th>Osnova</th>
                  <th>5%</th>
                </tr>
                <tr>
                  <th></th>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                  <th>6</th>
                  <th>7</th>
                  <th>8</th>
                  <th>9</th>
                  <th>10</th>
                  <th>10a</th>
                  <th>10b</th>
                  <th>11</th>
                  <th>12</th>
                  <th>13</th>
                  <th></th>
                  <th>14</th>
                  <th></th>
                  <th>15</th>
                  <th></th>
                  <th>15p</th>
                  <th>23</th>
                  <th>24</th>
                  <th>25</th>
                  <th>Stranka</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in invoices">
                  <td>{{ index + 1 }}</td>
                  <td>090</td>
                  <td>{{ invoice.issued.date | date }}</td>
                  <td>{{ invoice.premise.label + '-' + invoice.device.label + '-' + invoice.index, }}</td>
                  <td>{{ invoice.issued.date | date }}</td>
                  <td>
                    {{ invoice.payer.title }}<br>
                    <span v-if="invoice.payer.address">{{ invoice.payer.address }}</span><br>
                    <span v-if="invoice.payer.city">{{ invoice.payer.city }}</span><br>
                    <span v-if="invoice.payer.vat">({{ invoice.payer.vat }})</span>
                  </td>
                  <td></td>
                  <td>{{ invoice.services | totalAmount }}</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>{{ invoice.services | netAmount }}</td>
                  <td>{{ invoice.services | taxAmount  }}</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td></td>
                  <td>0.00</td>
                </tr>
                <tr>
                  <td colspan="7"></td>
                  <td>{{ totalAmount | price }}</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>{{ taxBase | price }}</td>
                  <td>{{ totalTax | price }}</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td></td>
                  <td>0.00</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
var XLSX = require('xlsx');
import { downloadXML } from "./downloadMinimaxXML.js";

export default {
  name: 'InvoiceReport',
  data: () => ({
    title: '',
    property: '',
    invoices: [],
    totalTax: 0,
    totalAmount: 0,
    taxBase: 0
  }),
  computed: {
    monthName: function(){
      if(!this.month) return '';
      return moment(this.month, 'MM').locale(this.$i18n.locale).format('MMMM');
    }
  },
  filters: {
    price: function(value){
      return value.toFixed(2)
    },
    date: function(input){
      return moment(input).format('DD/MM/YYYY');
    },
    totalAmount: function(services){
      let amount = 0;
      services.forEach(s => {
        if(s.taxRate == 9.5){
          amount += s.price * (100 / (100 + s.taxRate)) * s.quantity;
        }
      });
      return amount.toFixed(2);
    },
    netAmount: function(services){
      let amount = 0;
      services.forEach(s => {
        if(s.taxRate == 9.5){
          amount += s.price * (100 / (100 + s.taxRate)) * s.quantity;
        }
      });
      return amount.toFixed(2);
    },
    taxAmount: function(services){
      let amount = 0;
      services.forEach(s => {
        if(s.taxRate == 9.5){
          amount += s.price * s.taxRate / (100 + s.taxRate) * s.quantity;
        }
      });
      return amount.toFixed(2);
    }
  },
  created(){

    const propSlug = this.$route.params.property;

    this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
    this.year = this.$route.params.year;
    this.month = this.$route.params.month;

    let start = moment(this.year + '-' + this.month, "YYYY-M").startOf('month').format('YYYY-MM-DD');
    let end = moment(this.year + '-' + this.month, "YYYY-M").endOf('month').format('YYYY-MM-DD');
    let url = '/invoices?property._id=' + this.property._id + '&start=' + start +'&end=' + end;

    fetch(process.env.VUE_APP_API + url, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(result => {
      console.log(result);
      if(!result.error){
        return this.invoices = result;
        invoices.foreach(invoice => {
          invoice.services.foreach(service => {
            this.totalAmount += service.price * service.quantity;
            if(service.taxRate == 9.5){
              this.totalTax += service.price * service.quantity * (100 / (100 + service.taxRate));
              this.taxBase += service.price * service.quantity * (service.taxRate / (100 + service.taxRate));
            }
          })
        })
        console.log(this.invoices);
      }
    })
  },
  methods: {
    download(){
      console.log("function called");
      downloadXML(this.invoices);
    },
    excel(){
      let monthName = moment(this.month, 'M').locale(this.$i18n.locale).format('MMMM')
      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.table_to_sheet(document.getElementById('invoice-report'), {"raw": true});
      XLSX.utils.book_append_sheet(wb, ws, monthName);
      console.log(wb)
      XLSX.writeFile(wb, monthName + '_' + this.year + '.xlsx')
    }
  }
};
</script>

<i18n>
{
  "en": {
    "reports": {
      "name": "Reports",
      "url": "reports"
    },
    "invoices": {
      "issued" : "Issued Invoices"
    },
    "forProperty": "for property"
  },
  "sl": {
    "reports": {
      "name": "Poročila",
      "url": "porocila"
    },
    "invoices": {
      "issued": "Izdani računi"
    },
    "forProperty": "nastanitve"
  }
}
</i18n>
